import React from 'react';
import '../StyleSheets/ChartManager.css';
import DropDown from './DropDown';
import GraphDataItem from './GraphDataItem';
import LineChart from './LineChart';
import ExpandedPolicyEvent from './ExpandedPolicyEvent';
import FilterSelect from './FilterSelect';

import gsap from 'gsap';

export default class ChartManager extends React.Component {

    yAxesTypes = ['linear','logarithmic'];

    constructor(props) {
        super(props);

        this.chartContRef = React.createRef();

        const allData = props.coronaData;

        const dailyMeasuresOptions = [];
        props.appSettings.dailyMeasuresKeys.forEach( m=>{

            dailyMeasuresOptions.push( {key: m, title: allData.hebrew_legend[ m ].title } );

        });

        const policyEventsCategoryOptions = [];
        props.appSettings.policyEventsKeys.forEach( p => {

            policyEventsCategoryOptions.push( {key: p, title: allData.hebrew_legend[ p ].title } );

        });

        const countries = Object.keys( allData.data ).sort( (a,b) => {if(a==="ישראל") return -1; else return 1;});


        this.initActiveEvents = [];
        const eventList = props.appSettings.policyEventsKeys.map( (e,i) => {
            this.initActiveEvents.push( i < 3 );
            return {
                key: e,
                title: props.coronaData.hebrew_legend[e].title
            }
        });


        const curEvents = this.initActiveEvents.map( (e,i) => {if(e) return eventList[i].key; else return null})

        this.state = {

            covidData: allData,
    
            countries: countries,
            dailyMeasuresOptions: dailyMeasuresOptions,
            currentDailyDataType: props.appSettings.dailyMeasuresKeys[0],

            //TODO: remove:
            // currentEventsType: props.appSettings.policyEventsKeys[0],
            
            policyEventsCategoryOptions: policyEventsCategoryOptions,
            allEventsList: eventList,
            currentEventsTypes: curEvents,
            
            isDelta: false,
            isLog : false,
            isPerCapita: false,
            activeCountries: [ true, true, true, false, false, false ],

            expandedPolicyActive: false,
            expandedPolicyData: {}
        }

        this.handlePolicyPanelClose = this.handlePolicyPanelClose.bind(this);
        this.updateEventTypes = this.updateEventTypes.bind(this);
    }

    updateShowIndex(index, value) {
        const { activeCountries } = this.state
        const newActiveCountries = []
        for(let i=0;i<Math.max(activeCountries.length, index + 1);i++) {
            if(i === index) {
                newActiveCountries[i] = value
            } else {
                newActiveCountries[i] = activeCountries[ i ]
            }
        }
        // console.log(newActiveCountries)
        this.setState({
            activeCountries: newActiveCountries
        })
    }

    updateEventTypes( list ) {
        
        const curentEvents = [];

        for( let i=0; i<list.length; i++) {
            if( list[ i ] ) {

                curentEvents.push( this.state.allEventsList[i].key );
            }
        }

        this.setState( {currentEventsTypes: curentEvents} )
    }

    handlePolicyPanelClose() {
        this.setState({expandedPolicyActive: false});
    }

    componentDidMount() {

        gsap.from(this.chartContRef.current, {y:200, opacity:0, duration: 0.8, ease:"power3.out"});

    }

    render() {
        const {
            isDelta, 
            isPerCapita, 
            isPatientZeroDays, 
            activeCountries, 
            countries, 
            isLog,
            policyEventsCategoryOptions
        } = this.state
        
        const countriesToShow = []
        
        for(let i=0;i<countries.length;i++) {
            
            countriesToShow.push({name: countries[i], isActive: activeCountries[i]} );
            
        }

        return <div id="chartManagerCont" ref={this.chartContRef}>

                <DropDown key={"dailyDataSelect"} 
                    position={{r: "240px", t:"40px"}}
                    options={this.state.dailyMeasuresOptions} 
                    value={this.props.typeName} 
                    onChange={ e => { this.setState({currentDailyDataType: e.target.value}); }}
                    icon={"timeline"}
                />


                <FilterSelect 
                    title="סינון קטגוריות מדיניות"
                    theme="dark" 
                    list={ policyEventsCategoryOptions } 
                    position={{t: '40px', r: '500px'}}
                    activeItems={this.initActiveEvents}
                    bgColor="#ffffff"
                    onItemSelect={ this.updateEventTypes }
                />

                {/* <DropDown key={"policyTypeSelect"} 
                    position={{r: "540px", t:"40px"}}
                    options={this.state.policyEventsCategoryOptions} 
                    value={this.state.currentEventsType} 
                    onChange={ e => { this.setState({currentEventsType: e.target.value}); }}
                    icon={"trip_origin"}
                /> */}

                <div key="logButton" className="optionButton" id="logButton"
                    style={{opacity: isLog ? 1 : 0.2 }}
                    onClick={ e => { this.setState({isLog: !isLog, isDelta: false })} }
                >log</div>
                <div key="dayDeltaButton" className="optionButton" id="dayDeltaButton"
                    style={{opacity: isDelta ? 1 : 0.2 }}
                    onClick={ e => { this.setState({isDelta: !isDelta, isLog: false })} }
                >% שינוי יומי</div>
                <div key="perCapitaBtn" className="optionButton" id="perCapitaBtn"
                    style={{opacity: isPerCapita ? 1 : 0.2 }}
                    onClick={ e => { this.setState({isPerCapita: !isPerCapita })} }
                >per capita</div>

                <div key="patientZeroBtn" className="optionButton" id="patientZeroBtn"
                    style={{opacity: isPatientZeroDays ? 1 : 0.2 }}
                    onClick={ e => { this.setState({isPatientZeroDays: !isPatientZeroDays })} }
                >Patient Zero Days</div>
                <div key="graphDataItemsContainer" id="graphDataItemsContainer">
                    {
                        this.state.countries.map((_,i) => 
                            <GraphDataItem 
                                key={i+_} 
                                title={_} 
                                color={this.props.appSettings.colors[4 + i]} 
                                isActive={ activeCountries[ i ] } 
                                onToggle={ a=>{this.updateShowIndex(i, a)}}
                            />
                        )
                    }
                </div>
                <LineChart 
                    useToolTips = {true}
                    data={{
                        countries: countriesToShow,
                        color: this.props.appSettings.colors.slice( 4 ),
                        severityGradient: this.props.appSettings.severityGradient,
                        
                        //TODO: remove:
                        // eventsType: this.state.currentEventsType,

                        eventsTypes: this.state.currentEventsTypes,
                        dailyDataType: this.state.currentDailyDataType,
                        showDelta: isDelta,
                        showPerCapita: isPerCapita,
                        xAxisAsDaysSincePatientZero: isPatientZeroDays,
                        yAxesType: isLog ? this.yAxesTypes[ 1 ] : this.yAxesTypes[ 0 ],
                        coronaData:this.props.coronaData,
                    }}
                    onExpandPolicy={ data => this.setState( { expandedPolicyData: data, expandedPolicyActive: true } ) }
                />
                {this.state.expandedPolicyActive ? <ExpandedPolicyEvent 
                    onClose={ this.handlePolicyPanelClose }
                    data={ this.state.expandedPolicyData }
                /> : null }

        </div>
        
    }

}